module.exports = __webpack_public_path__ + "img/watermark.7f4144f8.png";